import axios from "axios";
import router from "@/router";
import store from "@/vuex";
import { Loading, Notification } from "element-ui";

// 创建axios实例
const service = axios.create({
  timeout: 60000, // 默认请求超时时间,不满足在api请求函数中传入参数timeout  之前默认为10000
});

let loadingInstance; // loading组件
let admin = null;

let warningShown = false; // 标志是否已经显示了警告

let cancelSources = [];   // 取消请求列表

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    // 为每个请求创建一个新的取消源  
    const source = axios.CancelToken.source();
    cancelSources.push(source);
    config.cancelToken = source.token;

    admin = config.admin;
    // console.log('%c接口请求路径：', 'background:pink;color:#666', config.url)
    const vuexStore = JSON.parse(localStorage.getItem('vuex') || '{}')
    if (admin) {
      if (vuexStore.user.adminToken) {
        config.headers["Authorization"] = vuexStore.user.adminToken;
        config.headers["X-Requested-With"] = "XMLHttpRequest";
      }
    } else {
      if (vuexStore.user.token) {
        config.headers["Authorization"] = vuexStore.user.token;
        config.headers["X-Requested-With"] = "XMLHttpRequest";
      }
    }
    // 增加noLoading字段判断是否需要loading(默认loading)
    if (!config.noLoading) {
      loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    }

    return Promise.resolve(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (res) => {
    // console.log('%c接口响应成功：', 'background:green;color:#fff', res)
    const status = res.status;
    if (status === 200 && res.data.success) {
      loadingInstance && loadingInstance.close();

      warningShown = false; // 复位warningShown状态
      return res.data.content;
    } else if (status === 200 &&
      !res.data.success &&
      res.data.content &&
      res.data.content.code &&
      res.data.content.code === 'StarGrantFailure'
    ) {
      loadingInstance && loadingInstance.close();
      Notification.warning({
        title: "警告",
        message: res.data.error.message,
      });
      return Promise.reject(res.data.error);
    } else if (
      status === 200 &&
      !res.data.success &&
      res.data.error &&
      res.data.error.code === "InvalidToken"
    ) {
      // 取消所有剩余的请求  
      cancelSources.forEach(source => {
        source.cancel('Token失效，已取消请求');
      });
      // 清空取消源数组  
      cancelSources = [];
      loadingInstance && loadingInstance.close();
      // console.log('------warningShown:', warningShown)
      if (!warningShown) {
        warningShown = true;
        // 其他代码...

        if (res.data.error.message) {
          Notification.warning({
            title: "警告",
            message: res.data.error.message,
          });
        } else {
          Notification.warning({
            title: "警告",
            message: "登录过期，请重新登录",
          });
        }

        if (admin) {
          store.dispatch("AdminLogOut").then(() => {
            // location.reload();
            router.push({
              path: "/background/login",
            });
          });
        } else {
          store.dispatch("LogOut").then(() => {
            // location.reload()
            router.push({
              path: "/login",
            });
          });
        }
      }

      return Promise.reject(res.data.error.message);
    } else {
      loadingInstance && loadingInstance.close();
      if (res.data.error.message === "无效的用户名或密码" || res.data.error.code === 'AuthFailure' || res.data.error.code === 'UpdatePasswordError' || res.data.error.code === 'ActionFailure' || res.data.error.code === 'InvalidParameter') {
        Notification.warning({
          title: "警告",
          message: res.data.error.message,
          duration: 2000
        });
      } else if (!warningShown) {
        warningShown = true;
        // 其他代码...
        console.log(res)
        if (res.data && res.data.content && res.data.content.code !== 'CaptchaFailure') {
          Notification.warning({
            title: "警告",
            message: res.data.error.message,
          });
        }
      }
      return Promise.reject(res.data.error);
    }
  },
  (err) => {
    // 取消所有剩余的请求  
    cancelSources.forEach(source => {
      source.cancel('Token失效，已取消请求');
    });
    // 清空取消源数组  
    cancelSources = [];
    if (err.message === 'Token失效，已取消请求') {
      return Promise.reject(err.message)
    }
    // 对响应错误做点什么
    // console.log('%c接口响应失败：', 'background:#f00;color:#fff', err)
    if (!warningShown && err.response && err.response.data && err.response.data) {
      const errData = err.response.data;
      const msg = errData.message ? errData.message : errData.error ? errData.error.message : '';
      Notification.warning({
        title: "警告",
        message: msg,
      });
      if (errData.error && errData.error.code === 'InvalidToken') {
        if (admin) {
          store.dispatch("AdminLogOut").then(() => {
            // location.reload();
            router.push({
              path: "/background/login",
            });
          });
        } else {
          store.dispatch("LogOut").then(() => {
            // location.reload()
            router.push({
              path: "/login",
            });
          });
        }
      }
      // warningShown = true
      loadingInstance && loadingInstance.close();
      return Promise.reject(err);
    }
    const message = err.message;
    console.log(message)
    if (message.includes("404")) {
      err.message = "404:服务器故障";
    } else if (message.includes("500")) {
      err.message = "500:服务器故障";
    } else if (message.includes("502")) {
      err.message = "502:服务器故障";
    } else if (err.message.includes("timeout")) {
      err.message = "请求超时,请刷新重试";
    } else if (err.message.includes("Token失效")) {
      err.message = "Token失效，已取消请求";
    } else {
      err.message = "未知错误";
    }
    loadingInstance && loadingInstance.close();

    if (!warningShown) {
      warningShown = true;
      // 其他代码...
      Notification.error({
        title: "错误",
        message: "网络异常，请刷新重试！",
      });
    }

    return Promise.reject(err.message);
  }
);

export default service;
